import { Link } from 'react-router-dom'
import styles from './ExhibitorManager.module.css'
import { useNavigate, useLocation } from 'react-router-dom'


const ExhibitorManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitorAccount = location.state    

    return (
        <div id={styles.eventConfigurePage}>
            <h1>Exhibitor Management</h1><br />
            <h2>Control exhibitor setup for {exhibitorAccount.firstName} {exhibitorAccount.lastName} - {exhibitorAccount.organization} ({exhibitorAccount.refNumber}).</h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/InvoiceManager`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Manage/print invoice, contact exhibitor, and assign exhibitor image.">
                    <h3>Manage Invoice</h3>
                </Link>
                <Link to={`/MobileAppManager`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Manage qualifiers and licenses for LR App.">
                    <h3>Manage Mobile App Account</h3>
                </Link>
                <Link to={`/elmah`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Manage exhibitor usb leads and print usb qualifiers.">
                    <h3>Manage USB Leads</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default ExhibitorManager;